__webpack_require__.p = "FRONTEND_SERVER_URL/APPLICATION_VERSION/";